/**------------------------------------------------------
 * Interface Definitions
 */
export abstract class AbstractStorage {
	abstract getItem(key: string): string | null;
	abstract setItem(key: string, value: string): void;
	abstract removeItem(key: string): void;
}
